import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { withStyles } from '@material-ui/core/styles';
import SidebarItem from './SidebarItem';
import { navbarItems, bottomNavItems } from '../helpers';
import Image from '../../components/Image';
import SocialLinks from '../../PublicFooter/components/SocialLinks';

const styles = theme => ({
    paper: {
        overflow: 'visible',
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        justifyContent: 'space-between',
    },
});

class Sidebar extends React.Component {
  render() {
    const { classes, show, toggleSidebar} = this.props;

    return (
        <SwipeableDrawer
            classes={{paper: classes.paper}}
            open={show}
            onClose={toggleSidebar(false)}
            onOpen={toggleSidebar(true)}
        >
            <div>
                <div className={classes.drawerHeader}>
                    <a href="/v2/home/" style={{alignSelf: 'center'}}>
                        <Image src="/homepage/direct-black-logo.svg" width="100"/>
                    </a>
                    <IconButton onClick={toggleSidebar(false)}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
            </div>
            <Divider />
            <List style={{paddingTop: 0}}>
                {navbarItems.map((props, i) => <SidebarItem key={i} {...props}/>)}
            </List>
            <Divider />
            <List style={{paddingTop: 0}}>
                {bottomNavItems.map((props, i) => <SidebarItem key={i} {...props}/>)}
            </List>
            <Divider/>
            <List style={{paddingTop: 0}}>
                <ListItem style={{padding: '2px 5px'}}>
                    <ListItemText primary={<SocialLinks/>} />
                </ListItem>
                <ListItem style={{paddingTop: 2, paddingBottom: 2, textAlign: 'center'}}>
                    <ListItemText primary="Follow Us!" />
                </ListItem>
            </List>
            <Divider/>
        </SwipeableDrawer>
    );
  }
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Sidebar);
